import React from 'react'
import { withTranslation } from 'react-i18next'
import * as UIcons from '@iconscout/react-unicons'
import StatusPill from './StatusPill'

const STATUS_TONE = { paid: 'success', verified: 'primary', pending: 'warning' }

export default withTranslation()(function RecentPayoutTransactionsCard({ t, rows = [], onViewAll, onRowClick }) {
  return (
    <div className="w-full bg-white border border-border-lines rounded-2xl p-6 flex flex-col gap-4">
      <div className="flex items-center justify-between gap-4">
        <p className="text-sm font-semibold text-dark-blue tracking-wide uppercase">{t('payout.recent_transactions.title')}</p>

        <button type="button" onClick={onViewAll} className="flex items-center gap-1.5 text-primary text-sm font-semibold whitespace-nowrap">
          {t('payout.recent_transactions.view_all')} <UIcons.UilArrowRight size={14} />
        </button>
      </div>

      <div className="w-full border border-border-lines rounded-lg overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left text-secondary bg-background">
                <th className="py-2.5 px-4 font-medium uppercase whitespace-nowrap">{t('payout.recent_transactions.columns.date')}</th>
                <th className="py-2.5 px-4 font-medium uppercase whitespace-nowrap">{t('payout.recent_transactions.columns.payout_id')}</th>
                <th className="py-2.5 px-4 font-medium uppercase whitespace-nowrap">{t('payout.recent_transactions.columns.prize_type')}</th>
                <th className="py-2.5 px-4 font-medium uppercase whitespace-nowrap">{t('payout.recent_transactions.columns.prize_name')}</th>
                <th className="py-2.5 px-4 font-medium uppercase whitespace-nowrap">{t('payout.recent_transactions.columns.winners')}</th>
                <th className="py-2.5 px-4 font-medium uppercase whitespace-nowrap">{t('payout.recent_transactions.columns.amount')}</th>
                <th className="py-2.5 px-4 font-medium uppercase whitespace-nowrap">{t('payout.recent_transactions.columns.status')}</th>
                <th className="py-2.5 px-4" />
              </tr>
            </thead>

            <tbody>
              {
                rows.length ? rows.map((row, index) => (
                  <tr
                    key={row.id ?? index}
                    className={`border-t border-border-lines ${onRowClick ? 'cursor-pointer hover:bg-background' : ''}`}
                    onClick={() => onRowClick && onRowClick(row)}
                  >
                    <td className="py-4 px-4 text-dark-blue whitespace-nowrap">{row.date}</td>
                    <td className="py-4 px-4 text-dark-blue whitespace-nowrap">{row.payoutId}</td>
                    <td className="py-4 px-4 text-dark-blue whitespace-nowrap">{row.prizeType}</td>
                    <td className="py-4 px-4 text-dark-blue whitespace-nowrap">{row.prizeName}</td>
                    <td className="py-4 px-4 text-dark-blue whitespace-nowrap">{row.winners}</td>
                    <td className="py-4 px-4 text-dark-blue whitespace-nowrap">{row.amount}</td>
                    <td className="py-4 px-4"><StatusPill text={row.statusLabel ?? row.status} tone={STATUS_TONE[row.status] ?? 'success'} /></td>
                    <td className="py-4 px-4 text-secondary"><UIcons.UilAngleRight size={16} /></td>
                  </tr>
                )) : (
                  <tr>
                    <td colSpan={8} className="text-center py-12">
                      <p className="font-semibold text-dark-blue">{t('payout.recent_transactions.empty_title')}</p>
                      <p className="text-sm text-secondary mt-1">{t('payout.recent_transactions.empty_hint')}</p>
                    </td>
                  </tr>
                )
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
})
